import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { NewButton, SaveButton } from "../../../components/Buttons";

export const Modifications = () => {
    document.title = "Sənədin Modifikasiyası";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ümumi anlayışlar", value: "/common" },
        { name: "Sənədin Modifikasiyası", value: "/common/modifications", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Sənədin Modifikasiyası</h2>
                    <p>
                        Sənədə müxtəlif modifikasiyalar təyin etmək olar. Bunun üçün sənədlərin icində <NewButton>Yeni modifikasiya</NewButton> düyməsini sıxıb,
                        modifikasiyanın adını və növünü təyin edib <SaveButton /> düyməsini sıxmaq lazımdır. Misal üçün, satış sənədində müştərinin ünvanı,
                        hansı satış kanalından gəldiyi, catdırılması, çatdıtılma edəcək əməkdaş, təyin olunan usta və s. modifikasiya əlavə edib daha sonrakı
                        axtarış əməliyyatlarında istifadə edə bilərsiniz.
                    </p>
                    <img src="/images/common/modifications.gif" alt="Sənədin Modifikasiyası" />
                </article>
            </div>
        </div>
    );
};
